// extracted by mini-css-extract-plugin
export default {"close":"SgX87X","headerContainer":"F4Ygtl","headerButton":"Ei4cUN","back":"oIqX_g","eventDetails":"AEsbpA","eventList":"Hlk00L","title":"DqUoxf","titlePadding":"IzotCX"};